'use strict';

(function (global) {
  const toolbarContentsSelector = '.toolbar_holder';

  /**
   * Класс-обертка для панели действий.
   * @class WebAccess.components.wrappers.toolBar.ToolBar
   * @since 5.5.0.9000
   */
  var ToolBar = BaseObject.extend({

    /**
     * Конструктор.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBar#init
     * @override
     */
    init: function () {
      this._super();

      // Подписаться на событие изменения размера окна для изменения размера панели действий.
      $(window).on('resizeEnd', () => this._resizeToolbar());

      // И нужно вызвать событие ресайза, чтобы панель действий подстроилась под размер окна.
      window.createResizeEndEvent($(window));

      // При нажатии вне области развернутой группы нужно скрыть ее
      $(document).mouseup((event) => {
        const groupContainer = $('.addedHiddenDiv:visible');
        if (!groupContainer.has(event.target).length) {
          groupContainer.hide();
        }
      });
    },

    /**
     * Список кнопок, уменьшенных при сжатии кнопок тулбара под размер доступнрого места.
     *
     * @property WebAccess.components.wrappers.toolBar.ToolBar#_shrinkedButtonsAfterResize
     */
    _shrinkedButtonsAfterResize: [],

    /**
     * Список кнопок панели действий.
     *
     * @property WebAccess.components.wrappers.toolBar.ToolBar#buttons
     */
    buttons: {},

    /**
     * Список групп кнопок панели действий.
     *
     * @property WebAccess.components.wrappers.toolBar.ToolBar#groups
     */
    groups: {},

    /**
     * Развернуть все разворачиваемые группы и кнопки тулбара.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBar#_restoreToolbar
     * @private
     * @since 5.6.0.9070
     */
    _restoreToolbar() {
      for (let button of this._shrinkedButtonsAfterResize) {
        button.showCaption();
      }
      this._shrinkedButtonsAfterResize = [];
    },

    /**
     * Получить кнопку, которая может быть сокращена до иконки, из группы тулбара с наиболее низким приоритетом (в
     *     которой ещё остались такие кнопки).
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBar#__getNextButtonWithCaption
     * @private
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton || null} Кнопка тулбара, которая может быть
     *     сокращена до иконки, или NULL, если таких кнопок не осталось.
     * @since 5.6.0.9070
     * @summary Получить кнопку с отображаемым названием.
     */
    _getNextButtonWithCaption() {
      const toolbarGroups = this.groups.toArray();
      let priority = Infinity;
      let buttonWithCaptionInLowPriorityGroup = null;
      for (let group of toolbarGroups) {
        const groupPriority = group.priority || 0;
        if (groupPriority < priority) {
          const toolbarButtons = group.getButtons().toArray();
          const buttonWithCaption = toolbarButtons.find((button) => button.isCaptionVisible());
          if (buttonWithCaption) {
            buttonWithCaptionInLowPriorityGroup = buttonWithCaption;
            priority = groupPriority;
          }
        }
      }
      return buttonWithCaptionInLowPriorityGroup;
    },

    /**
     * Признак скрытого тулбара.
     *
     * @method getIsHidden
     * @return {boolean} True - тулбар скрыт, иначе False.
     */
    getIsHidden() {
      const jToolbar = $(toolbarContentsSelector);
      return !jToolbar.is(':visible');
    },

    /**
     * Вписать панель действий по размеру окна.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBar#resizeToolbar
     * @since 5.6.0.0000
     */
    resizeToolbar() {
      // TODO Избавиться от приватного метода
      this._resizeToolbar();
    },

    /**
     * Вписать панель действий по размеру окна.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBar#_resizeToolbar
     * @private
     * @since 5.6.0.1300
     */
    _resizeToolbar() {
      $.when(WA.ToolBarInit).done(() => {
        const jToolbarContents = $(toolbarContentsSelector);
        const width = this._getAvailableWidth();

        // Спрячем содержимое тулбара пока идут трансформации, чтоб не дёргался.
        jToolbarContents.hide();

        // Развернём тулбар до его изначального состояния (до такого, каким он пришёл с сервера).
        this._restoreToolbar();

        while (!this._canFitToWidth(width)) {
          const buttonWithCaption = this._getNextButtonWithCaption();
          // Если больше не нашлось кнопки с отображаемым названием.
          if (!buttonWithCaption) {
            break;
          }
          this._shrinkedButtonsAfterResize.push(buttonWithCaption);
          buttonWithCaption.hideCaption();
        }

        jToolbarContents.show();
      });
    },

    /**
     * Узнать, вмещаются ли элементы тулбара в контейнер тулбара.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBar#_canFitToWidth
     * @private
     * @return {boolean} TRUE - если элементы тулбара вмещаются в контейнер для тулбара, иначе - FALSE.
     * @since 5.6.0.9075
     */
    _canFitToWidth(width) {
      const toolbarWidth = $(toolbarContentsSelector).width();
      return width > toolbarWidth;
    },

    /**
     * Получить ширину списка объектов.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBar#_getAvailableWidth
     * @private
     * @return {number} Ширина списка объектов в px.
     * @since 5.6.0.9075
     */
    _getAvailableWidth() {
      let availableWidth = $(window).width();

      if (WA.getLocation() === 'explorer') {
        // В левой колонке дерево папок.
        const jLeftColumn = $('#left_column');
        if (jLeftColumn.length) {
          availableWidth -= jLeftColumn.width();
        }
      } else {
        const jAttachments = $('.attachments_td');
        if (jAttachments.length) {
          availableWidth -= jAttachments.width();
        }
      }

      return availableWidth - 10;
    },
  });

  global.ToolBar = ToolBar;

})(window.WA.components.wrappers.toolBar);
